class CalculatorContext {
    constructor(config, calculatorFields) {
        this.config = config;
        this.calculatorFields = calculatorFields;
    }
}
function generateCalculatorFields(calcIds) {
    return {
        //Amount fields
        id: calcIds,
        inputAmount: document.getElementById(`inputAmount${calcIds}`),
        rangeAmount: document.getElementById(`rangeAmount${calcIds}`),
        fromAmountDisplay: document.getElementById(`fromAmountDisplay${calcIds}`),
        toAmountDisplay: document.getElementById(`toAmountDisplay${calcIds}`),
        //Period fields
        inputPeriod: document.getElementById(`inputPeriod${calcIds}`),
        rangePeriod: document.getElementById(`rangePeriod${calcIds}`),
        periods: document.getElementById(`periods${calcIds}`),
        installmentFrom: document.getElementById(`installmentFrom${calcIds}`),
        rrsoDiv: document.getElementById(`rrso${calcIds}`),
        loanButton: document.getElementById(`calc-get-loan${calcIds}`),
        //Details
        installmentAmount: document.getElementById(`installmentAmount${calcIds}`),
        datepicker: document.getElementById(`datepicker${calcIds}`),
        datepickerMobile: document.getElementById(`datepickerMobile${calcIds}`),
        totalAmountInterest: document.getElementById(`totalAmountInterest${calcIds}`),
        totalAmountInterestMobile: document.getElementById(`totalAmountInterestMobile${calcIds}`),
        totalCommissions: document.getElementById(`totalCommissions${calcIds}`),
        totalCommissionsMobile: document.getElementById(`totalCommissionsMobile${calcIds}`),
        totalAmountToPay: document.getElementById(`totalAmountToPay${calcIds}`),
        totalAmountToPayMobile: document.getElementById(`totalAmountToPayMobile${calcIds}`),
        paymentDate: document.getElementById(`payment-date${calcIds}`),
        paymentDateMobile: document.getElementById(`payment-dateMobile${calcIds}`),
        formLinks: {
            formLink: document.getElementById(`calc-link${calcIds}`),
            formLinkMobile: document.getElementById(`calc-link-mobile${calcIds}`)
        },
        promoBar:document.getElementById(`promo-bar-${calcIds}`)
    };
}

function generatePreviewCalculatorFields() {
    return new Promise((resolve) => {
        const fields = {
            //Installments fields
            inputInstallments: document.getElementById(`inputInstallments`),
            rangeInstallments: document.getElementById(`rangeInstallments`),
            fromInstallmentsDisplay: document.getElementById(`fromInstallmentsDisplay`),
            toInstallmentsDisplay: document.getElementById(`toInstallmentsDisplay`),
            //Amount Left fields
            inputAmountLeft: document.getElementById(`inputAmountLeft`),
            rangeAmountLeft: document.getElementById(`rangeAmountLeft`),
            fromAmountLeftDisplay: document.getElementById(`fromAmountLeftDisplay`),
            toAmountLeftDisplay: document.getElementById(`toAmountLeftDisplay`),
            //Cash fields
            inputCash: document.getElementById(`inputCash`),
            rangeCash: document.getElementById(`rangeCash`),
            fromCashDisplay: document.getElementById(`fromCashDisplay`),
            toCashDisplay: document.getElementById(`toCashDisplay`),
            //Period fields
            inputPeriod: document.getElementById(`inputPreviewPeriod`),
            rangePeriod: document.getElementById(`rangePreviewPeriod`),
            fromPreviewPeriodDisplay: document.getElementById(`fromPreviewPeriodDisplay`),
            toPreviewPeriodDisplay: document.getElementById(`toPreviewPeriodDisplay`),
            //Details
            installmentAmount: document.getElementById(`installmentAmount`),
            rrso: document.getElementById(`rrso`),
            interest: document.getElementById(`interest`),
            commission: document.getElementById(`commission`),
            lowerInstallment: document.getElementById(`box-cond-labels-val`),
            loanButton: document.getElementById(`calc-get-loan`),
            datepicker: document.getElementById(`datepicker`),
            totalAmountInterest: document.getElementById(`totalAmountInterest`),
            totalCommissions: document.getElementById(`totalCommissions`),
            totalAmountToPay: document.getElementById(`totalAmountToPay`),
            paymentDate: document.getElementById(`payment-date`),
            formLink: document.getElementById(`calc-link`),
        }
        resolve(fields);
    });
}

export {CalculatorContext, generateCalculatorFields, generatePreviewCalculatorFields};
